import React from 'react';
import { Section, FadeIn } from './ui/Section';
export function WhyItFails() {
  return <Section background="white" data-id="element-338">
      <FadeIn data-id="element-339">
        <h2 className="text-3xl md:text-4xl font-serif text-[#3D1F2E] mb-12 text-center leading-tight" data-id="element-340">
          Por qué lo que ya intentaste no funcionó <br data-id="element-341" />
          <span className="text-[#7A5C6B] text-2xl md:text-3xl" data-id="element-342">
            (y no es tu culpa)
          </span>
        </h2>
      </FadeIn>

      <div className="grid gap-8 md:grid-cols-2" data-id="element-343">
        <FadeIn delay={0.2} data-id="element-344">
          <div className="h-full p-8 border border-[#E8D5DC] rounded-xl bg-[#FFF5F0]/80 backdrop-blur-sm" data-id="element-345">
            <h3 className="text-xl font-bold text-[#3D1F2E] mb-4 font-serif" data-id="element-346">
              Presupuestos rígidos
            </h3>
            <p className="text-[#7A5C6B]" data-id="element-347">
              Fallan por una razón: llegan tarde. El presupuesto vive en tu
              cabeza "racional". El impulso aparece en tu cuerpo cansado,
              ansioso, buscando dopamina.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-348">
          <div className="h-full p-8 border border-[#E8D5DC] rounded-xl bg-[#FFF5F0]/80 backdrop-blur-sm" data-id="element-349">
            <h3 className="text-xl font-bold text-[#3D1F2E] mb-4 font-serif" data-id="element-350">
              Apps de finanzas
            </h3>
            <p className="text-[#7A5C6B]" data-id="element-351">
              Fallan porque se vuelven otra tarea y, cuando hay culpa, lo
              primero que haces es evitarlas.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-352">
          <div className="h-full p-8 border border-[#E8D5DC] rounded-xl bg-[#FFF5F0]/80 backdrop-blur-sm" data-id="element-353">
            <h3 className="text-xl font-bold text-[#3D1F2E] mb-4 font-serif" data-id="element-354">
              Disciplina pura
            </h3>
            <p className="text-[#7A5C6B]" data-id="element-355">
              Falla porque no es infinita. Se gasta. Especialmente en días
              largos.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-356">
          <div className="h-full p-8 flex items-center justify-center text-center" data-id="element-357">
            <p className="text-xl font-serif italic text-[#C4467E]" data-id="element-358">
              Lo que necesitas no es "ser otra persona". Es instalar un sistema
              que funcione con tu vida real, no con tu vida ideal.
            </p>
          </div>
        </FadeIn>
      </div>
    </Section>;
}